import React from 'react';

export const LandingContext = React.createContext({});

LandingContext.displayName = 'LandingContext';

export default LandingContext;
